import { Reading } from "@edp-pages/readings/components/readings-model";

export interface IReadingState {
    readings: Reading[][];
    uploadReadingElectricity: boolean;
    uploadReadingGas: boolean;
}

export const initialReadingState: IReadingState = {
    readings: [],
    uploadReadingElectricity: null,
    uploadReadingGas: null,
};
